module.exports = __webpack_public_path__ + "img/sg_feature2.d316044a.jpg";